

<template>
  <div id="data-list-thumb-view" class="data-list-container mt-10">
    <vs-popup
      classContent="popup-example"
      v-if="addressItem"
      :title="$store.state.getLabel($store.state.language).shipAddress"
      :active.sync="popupActive2"
    >
      <p class="text-sm mb-4">
        <span class="cursor-pointer" style="white-space: pre-line;">{{ addressItem.orderAddress }}</span>
        <span
          class="cursor-pointer"
          style="white-space: pre-line;"
        >{{$store.state.getLabel($store.state.language).phone}} {{ addressItem.orderPhone }}</span>
      </p>
    </vs-popup>
    <data-view-sidebar
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      :data="sidebarData"
    />

    <vs-table
      v-if="usr"
      ref="table"
      multiple
      v-model="selected"
      pagination
      :max-items="itemsPerPage"
      search
      :data="products"
    >
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center">
          <vs-button class="mx-2" @click.stop="signOut();">登出</vs-button>
          <!-- ACTION - DROPDOWN -->
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span
              class="mr-2"
            >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ products.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : products.length }} of {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="orderId">訂單編號</vs-th>
        <vs-th sort-key="orderRestaurant">訂單內容</vs-th>
        <vs-th sort-key="orderPhone">電話</vs-th>
        <vs-th sort-key="orderAddress">地址</vs-th>
        <vs-th sort-key="orderDeliverer">車手</vs-th>
        <vs-th sort-key="orderRemarksInt">內部備註</vs-th>
        <vs-th sort-key="orderStatus">訂單狀態</vs-th>
        <vs-th sort-key="orderAmount">總額</vs-th>
        <vs-th>操作</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" :value="displayCheck" v-for="(tr, indextr) in data" v-if="tr.orderStatus !== 'X'">
            <vs-td class="img-container">
              <p class="product-name font-medium">{{ tr.orderId }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium" style="color:blue">{{tr.orderRestaurantName}}</p>
              <p
                class="product-name font-medium"
                style="white-space: pre-line;"
              >{{ tr.orderRestaurantInt }}</p>
              <p
                class="product-name font-medium mt-4"
                style="white-space: pre-line;"
              >備註: {{ tr.remarks }}</p>

              <p
                class="product-name font-medium mt-4"
                style="white-space: pre-line;"
              >付款方式: {{ tr.paymentMethod }}</p>
              <p class="product-name font-medium mt-4">建立時間: {{ tr.createTime }}</p>
            </vs-td>

            <vs-td>
              <p class="product-category">{{ tr.orderPhone }} ({{tr.orderPerson}})</p>
            </vs-td>

            <vs-td>
              <p class="product-category" style="white-space: pre-line;">{{ tr.orderAddress }}</p>
            </vs-td>

            <vs-td>
              <p
                :class="tr.orderDeliverer == null ?'text-primary font-bold':'text-success font-bold'"
              >{{ tr.orderDeliverer == null ? '未指派' : delivererList.filter(c => c.value.indexOf(tr.orderDeliverer) > -1)[0].text + ' ' + tr.orderDeliverer }}</p>
            </vs-td>

            <vs-td>
              <p
                class="product-category"
                style="white-space: pre-line;"
              >{{ tr.remarksInt?tr.remarksInt:"" }}</p>
            </vs-td>

            <vs-td>
              <vs-chip
                :color="getOrderStatusColor(tr.orderStatus)"
                class="product-order-status font-bold"
              >{{ getOrderStatus(tr.orderStatus) }}</vs-chip>
            </vs-td>

            <vs-td>
              <p class="product-price">${{ tr.orderAmount }}</p>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <p>
                <vs-button class="mx-2 small" @click.stop="confirmWhatsapp30(tr)">1. 確認訂單($30)</vs-button>
                <vs-button class="mx-2 small" @click.stop="confirmWhatsapp60(tr)">1. 確認訂單($60)</vs-button>
                <vs-button class="mx-2 small" @click.stop="confirmWhatsapp90(tr)">1. 確認訂單($90)</vs-button>
                
              </p>
              <p class="mt-2">
                
                <vs-button
                  class="mx-2 small"
                  :disabled="!tr.orderDetail.orderContact"
                  @click.stop="confirmRestaurant(tr)"
                >{{tr.orderDetail.orderContact?'2. 叫外賣':'無餐廳Whatsapp'}}</vs-button>
                <vs-button
                  class="mx-2 small"
                  :disabled="!tr.orderDetail.orderContact"
                  @click.stop="confirmRestaurantEng(tr)"
                >{{tr.orderDetail.orderContact?'2. 叫外賣(ENG)':'無餐廳Whatsapp'}}</vs-button>
                <vs-button class="mx-2 small" @click.stop="payOrder(tr)">3. 要求收款</vs-button>
                <vs-button class="mx-2 small" @click.stop="editData(tr);">4. 更新準備</vs-button>
                
              </p>
              <p class="mt-2">
                <vs-button
                  class="mx-2 small"
                  :disabled="tr.orderDeliverer == null"
                  @click.stop="contactDeliverer(tr)"
                >5. 通知車手</vs-button>
                <vs-button class="mx-2 small" @click.stop="editData(tr);">6. 更新運送</vs-button>
                <vs-button class="mx-2 small" @click.stop="editData(tr);">7. 更新完成</vs-button>
              </p>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import DataViewSidebar from "../DataViewSidebar.vue";

export default {
  components: {
    DataViewSidebar
  },

  data() {
    return {
      delivererList: [
        { text: "Abe", value: "93206366" },
        { text: "Max", value: "55963321" },
        { text: "Ken", value: "93096608" },
        { text: "耀裕", value: "44029499" },
        { text: "蘭", value: "69969654" },
        { text: "Tszling", value: "60200166" },
        { text: "Vivi", value: "92487871" },
        { text: "May", value: "56800683" },
        { text: "Pan", value: "93781129" },
        { text: "日", value: "64626286" },
        { text: "Hailey", value: "96084925" },
        { text: "Ming", value: "62340126" },
        { text: "Joe", value: "62045449" },
        { text: "阿肥", value: "93111346"},
        { text: "樂", value: "46757572"},
        { text: "Hotwing", value: "51333551"},
        { text: "昇", value: "98463918"},
        { text: "朱", value: "92073476"}
      ],
      selected: [],
      // products: [],
      itemsPerPage: 10,
      isMounted: false,
      addNewDataSidebar: false,
      sidebarData: {},
      popupActive2: false,
      addressItem: null
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    products() {
      return this.$store.state.orders;
    },
    queriedItems() {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.products.length;
    }
  },
  methods: {
    replaceall(str, replace, with_this) {
      var str_hasil = "";
      var temp;

      for (
        var i = 0;
        i < str.length;
        i++ // not need to be equal. it causes the last change: undefined..
      ) {
        if (str[i] == replace) {
          temp = with_this;
        } else {
          temp = str[i];
        }

        str_hasil += temp;
      }

      return str_hasil;
    },
    fee30(data) {
        window.open(
          "https://api.whatsapp.com/send?phone=852" +
            data.orderPhone +
             "&text=*****火紅蟻外賣平台*****"+"%0a你的送餐區域屬於$30運費"
             +"%0aYour delivery area is classified as $30" + "%0a%0a請通過Payme付款 金額: $" +
            data.orderAmount + " + $30 = $" + (data.orderAmount+30) +
            " 至 https://qr.payme.hsbc.com.hk/2/6KcN2dYsgGg2zMMDCqxKmB %0a收到款項後我們便會為你即時處理訂單",
          "_blank"
        );
    },
    fee60(data) {
        window.open(
          "https://api.whatsapp.com/send?phone=852" +
            data.orderPhone +
             "&text=*****火紅蟻外賣平台*****"+"%0a你的送餐區域屬於$60運費"
             +"%0aYour delivery area is classified as $60" + "%0a%0a請通過Payme付款 金額: $" +
            data.orderAmount + " + $60 = $" + (data.orderAmount+60) +
            " 至 https://qr.payme.hsbc.com.hk/2/6KcN2dYsgGg2zMMDCqxKmB %0a收到款項後我們便會為你即時處理訂單",
          "_blank"
        );
    },
    fee90(data) {
        window.open(
          "https://api.whatsapp.com/send?phone=852" +
            data.orderPhone +
             "&text=*****火紅蟻外賣平台*****"+"%0a你的送餐區域屬於$90運費"
             +"%0aYour delivery area is classified as $90" + "%0a%0a請通過Payme付款 金額: $" +
            data.orderAmount + " + $90 = $" + (data.orderAmount+90) +
            " 至 https://qr.payme.hsbc.com.hk/2/6KcN2dYsgGg2zMMDCqxKmB %0a收到款項後我們便會為你即時處理訂單",
          "_blank"
        );
    },
    discount15(data) {
        window.open(
          "https://api.whatsapp.com/send?phone=852" +
            data.orderPhone +
             "&text=*****火紅蟻新推出8月抗疫優惠*****"+"%0a由於你買滿$400，我地喺運費一欄即時為你減左半價！！！"
             +"%0a提提你優惠係做到8月31日，仲可以無限次使用，錯過左就唔知幾時再有，請你繼續支持火紅蟻！" + "%0a%0a請通過Payme付款 金額: $" +
            data.orderAmount + " - $15 = $" + (data.orderAmount-15) +
            " 至 https://qr.payme.hsbc.com.hk/2/6KcN2dYsgGg2zMMDCqxKmB %0a收到款項後我們便會為你即時處理訂單",
          "_blank"
        );
    },
    discount30(data) {
        window.open(
          "https://api.whatsapp.com/send?phone=852" +
            data.orderPhone +
             "&text=*****火紅蟻新推出8月抗疫優惠*****"+"%0a由於你買滿$400，我地喺運費一欄即時為你減左半價！！！"
             +"%0a提提你優惠係做到8月31日，仲可以無限次使用，錯過左就唔知幾時再有，請你繼續支持火紅蟻！" + "%0a%0a請通過Payme付款 金額: $" +
            data.orderAmount + " - $30 = $" + (data.orderAmount-30) +
            " 至 https://qr.payme.hsbc.com.hk/2/6KcN2dYsgGg2zMMDCqxKmB %0a收到款項後我們便會為你即時處理訂單",
          "_blank"
        );
    },
    discount45(data) {
        window.open(
          "https://api.whatsapp.com/send?phone=852" +
            data.orderPhone +
             "&text=*****火紅蟻新推出8月抗疫優惠*****"+"%0a由於你買滿$400，我地喺運費一欄即時為你減左半價！！！"
             +"%0a提提你優惠係做到8月31日，仲可以無限次使用，錯過左就唔知幾時再有，請你繼續支持火紅蟻！" + "%0a%0a請通過Payme付款 金額: $" +
            data.orderAmount + " - $45 = $" + (data.orderAmount-45) +
            " 至 https://qr.payme.hsbc.com.hk/2/6KcN2dYsgGg2zMMDCqxKmB %0a收到款項後我們便會為你即時處理訂單",
          "_blank"
        );
    },
    confirmWhatsapp30(data) {
        window.open(
          "https://api.whatsapp.com/send?phone=852" +
            data.orderPhone +
            "&text=*****火紅蟻外賣平台*****%0a%0aHello!! " +
            data.orderPerson +
            ":%0a%0a我們已收到閣下的訂單 :" +
            "%0aWe have received your order : *" +
            data.orderId.replace("#", "") +
            "*%0a%0a"+data.orderRestaurantName + "%0a" + 
            data.orderRestaurantNameEng +
            "%0a%0a訂單詳情：" + 
            "%0aOrder Detail：%0a" +
            this.replaceall(data.orderRestaurantWtsappChi, '&', '%26') +
            "%0a送貨地址:" +
            "%0aAddress:" +
            data.orderAddress +
            "%0a%0a你的送餐區域屬於$30運費"
            +"%0aYour delivery area is classified as $30%0a"+
            "%0a總金額(Total): $" +
            data.orderAmount + " ＋ $30 = $" + (data.orderAmount+30) +
            "%0a%0a請稍等 我地會先向餐廳確認食材 後付款☺️"+
            "%0aWe will check the ingredients of restaurant to make sure that everything runs smoothly%0a%0a請選擇付款方式: 現金 Payme 轉數快%0aPlease select a payment method:%0aCASH, PAYME or FPS",
          "_blank"
        );
    },
    confirmWhatsapp60(data) {
        window.open(
          "https://api.whatsapp.com/send?phone=852" +
            data.orderPhone +
            "&text=*****火紅蟻外賣平台*****%0a%0aHello!! " +
            data.orderPerson +
            ":%0a%0a我們已收到閣下的訂單 :" +
            "%0aWe have received your order : *" +
            data.orderId.replace("#", "") +
           "*%0a%0a"+data.orderRestaurantName + "%0a" + 
            data.orderRestaurantNameEng +
            "%0a%0a訂單詳情：" + 
            "%0aOrder Detail：%0a" +
            this.replaceall(data.orderRestaurantWtsapp, '&', '%26') +
            "%0a送貨地址:" +
            "%0aAddress:" +
            data.orderAddress +
            "%0a%0a你的送餐區域屬於$60運費"
            +"%0aYour delivery area is classified as $60%0a"+
            "%0a總金額(Total): $" +
            data.orderAmount + " ＋ $60 = $" + (data.orderAmount+60) +
            "%0a%0a請稍等 我地會先向餐廳確認食材 後付款☺️"+
            "%0aWe will check the ingredients of restaurant to make sure that everything runs smoothly%0a%0a請選擇付款方式: 現金 Payme 轉數快%0aPlease select a payment method:%0aCASH, PAYME or FPS",
          "_blank"
        );
    },
    confirmWhatsapp90(data) {
        window.open(
          "https://api.whatsapp.com/send?phone=852" +
            data.orderPhone +
            "&text=*****火紅蟻外賣平台*****%0a%0aHello!! " +
            data.orderPerson +
            ":%0a%0a我們已收到閣下的訂單 :" +
            "%0aWe have received your order : *" +
            data.orderId.replace("#", "") +
            "*%0a%0a"+data.orderRestaurantName + "%0a" + 
            data.orderRestaurantNameEng +
            "%0a%0a訂單詳情：" + 
            "%0aOrder Detail：%0a" +
            this.replaceall(data.orderRestaurantWtsapp, '&', '%26') +
            "%0a送貨地址:" +
            "%0aAddress:" +
            data.orderAddress +
            "%0a%0a你的送餐區域屬於$90運費"
            +"%0aYour delivery area is classified as $90%0a"+
            "%0a總金額(Total): $" +
            data.orderAmount + " ＋ $90 = $" + (data.orderAmount+90) +
            "%0a%0a請稍等 我地會先向餐廳確認食材 後付款☺️"+
            "%0aWe will check the ingredients of restaurant to make sure that everything runs smoothly%0a%0a請選擇付款方式: 現金 Payme 轉數快%0aPlease select a payment method:%0aCASH, PAYME or FPS",
          "_blank"
        );
    },
    payOrder(data) {
        window.open(
          "https://api.whatsapp.com/send?phone=852" +
            data.orderPhone +
            "&text=請通過Payme付款 金額: $" +
            data.orderAmount +
            " 至 https://qr.payme.hsbc.com.hk/2/6KcN2dYsgGg2zMMDCqxKmB %0a收到款項後我們便會為你即時處理訂單",
          "_blank"
        );
    },
    confirmRestaurant(data) {
      window.open(
        "https://api.whatsapp.com/send?phone=852" +
          data.orderDetail.orderContact +
          "&text=*****火紅蟻外賣平台*****%0a " +
          "%0a訂單 *:" +
          data.orderId.replace("#", "") +
          "*%0a%0a"+data.orderRestaurantName + 
          "%0a%0a訂單詳情：%0a" + 
          this.replaceall(data.orderRestaurantWtsapp, '&', '%26') +
            "%0a總金額: $" +
            data.orderAmount +
          "%0a%0a備註:" +
          data.remarks +
          "*%0a取餐員：%0a" +
          data.orderDeliverer +
          "(" +
          this.delivererList.filter(
            c => c.value.indexOf(data.orderDeliverer) > -1
          )[0].text +
          ")"+
          "%0a%0a*為方便埋數，麻煩回覆訂單價錢 謝謝*",
        "_blank"
      );
    },
    confirmRestaurantEng(data) {
      window.open(
        "https://api.whatsapp.com/send?phone=852" +
          data.orderDetail.orderContact +
          "&text=*****RedAntFood*****%0a " +
          "%0aOrder *:" +
          data.orderId.replace("#", "") +
          "*%0a%0a"+
            data.orderRestaurantNameEng +
          "%0a%0aOrderDetail：%0a" + 
          this.replaceall(data.orderRestaurantWtsappEng, '&', '%26') +
          "%0aTotal: $" +
            data.orderAmount +
          "%0a%0aRemark:" +
          data.remarks +
          "*%0aDeliver Man：%0a" +
          data.orderDeliverer +
          "(" +
          this.delivererList.filter(
            c => c.value.indexOf(data.orderDeliverer) > -1
          )[0].text +
          ")"+
          "%0a%0a*Please reply us the price total for record, Thanks.*",
        "_blank"
      );
    },
    contactDeliverer(data) {
      window.open(
        "https://api.whatsapp.com/send?phone=852" +
          data.orderDeliverer +
          "&text=*****火紅蟻外賣平台*****%0a%0a*訂單:" +
          data.orderId.replace("#", "") +
          "*%0a%0a"+data.orderRestaurantName + 
          "%0a%0a訂單詳情：%0a" + 
          this.replaceall(data.orderRestaurantWtsapp, '&', '%26') +
          "%0a備註:" +
          data.remarks +
          "%0a%0a送貨地址:" +
          data.orderAddress +
          "%0a顧客電話:" +
          data.orderPhone +
          "(" +
          data.orderPerson +
          ")",
        "_blank"
      );
    },
    editData(data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      var dataItem = {
        id: data.firebaseId,
        orderId: data.orderId,
        remarksInt: data.remarksInt,
        orderStatus: data.orderStatus,
        orderAmount: data.orderAmount,
        deliverer: data.orderDeliverer,
        orderPhone: data.orderPhone,
        orderPerson: data.orderPerson,
        orderLang: data.orderLang
      };
      this.sidebarData = dataItem;
      this.toggleDataSidebar(true);
    },
    getAddressForPopup(item) {
      this.addressItem = item;
      this.popupActive2 = true;
    },
    getOrderStatusColor(status) {
      if (status == "S") return "danger";
      if (status == "WP") return "warning";
      if (status == "C") return "success";
      return "danger";
    },
    getOrderStatus(status) {
      if (status == "S") return "運送中";
      if (status == "P") return "準備中";
      if (status == "WP") return "待付款";
      if (status == "X") return "已取消";
      return "已完成";
    },
    getPopularityColor(num) {
      if (num > 90) return "success";
      if (num > 70) return "primary";
      if (num >= 50) return "warning";
      if (num < 50) return "danger";
      return "primary";
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
    signOut() {
      this.$store.dispatch("signOutUser");
    }
  },
  created() {
    const usr = this.$store.state.getUserInfo();
    this.usr = usr.email;
    if (usr.email == "admin2@redantfood.com" || usr.email == "sys@redantfood.com") {
      this.$store.dispatch("fetchOrderListItems");
    }
  },
  mounted() {
    const usr = this.$store.state.getUserInfo();
    if (usr == null) {
      this.$router.push("/");
      return;
    }
    if (usr.email != "admin2@redantfood.com" && usr.email != "sys@redantfood.com") {
      this.$router.push("/");
    }
    this.isMounted = true;
  }
};
</script>

<style lang="scss">
#data-list-thumb-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 10px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
          &.img-container {
            // width: 1rem;
            // background: #fff;

            span {
              display: flex;
              justify-content: flex-start;
            }

            .product-img {
              height: 110px;
            }
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
